import { isThirdPartyIntegrations } from 'app/policies/config';
import { USER_ROLES } from 'app/services/users.service';

function canPermissions(user) {
  return user?.role_guid !== USER_ROLES.helpDesk;
}

function canDelete(user) {
  return user?.role_guid !== USER_ROLES.helpDesk && user?.role_guid !== USER_ROLES.publisher;
}

export function permissionsRol(user) {
  return {
    readList: true,
    readDetail: canPermissions(user),
    create: canPermissions(user),
    update: canPermissions(user),
    delete: canDelete(user),
    deleteOwner: true,
    clone: canPermissions(user),

    // TABLE:
    columnISBN: !isThirdPartyIntegrations(user),

    // DETAIL:
    showISBN: !isThirdPartyIntegrations(user),
  };
}
